/**
 * Black Friday 2026 campaign constants, shared by the landing page
 * (`pages/black-friday-giveaway.vue`) and its components.
 *
 * Everything market-specific (the 20 % vs 30 % wording, currencies, and the
 * prize draw that only /cs, /sk and /de run) lives in the per-market message
 * files `layers/i18n/locales/black-friday/<code>.json`, not here. That keeps the draw
 * out of the code the other eight markets download, as the campaign brief
 * requires.
 */

/** The campaign coupon. It must match the promotion's code in every channel. */
export const BLACK_FRIDAY_CODE = 'BLACKFRIDAY'

/**
 * Where "Shop now" leads: the whole sale. The buttons add `?code=BLACKFRIDAY`
 * to it, which is what applies the code — see `useBlackFridayShopLink`.
 */
export const BLACK_FRIDAY_SHOP_PATH = '/collections/sale'

/** The campaign terms, a @nuxt/content page in every market (`content/<locale>/black-friday-terms.md`). */
export const BLACK_FRIDAY_TERMS_PATH = '/black-friday-terms'

/** Hand-placed campaign art and video under `public/`. */
export const BLACK_FRIDAY_ASSETS = '/landing/black-friday'
